import api from "../helpers/axios";

/**
 * Notification authoring service (GS-admin-web).
 *
 * Hits the same internal backend as incidents/feedback (via the shared `api`
 * axios instance) — NOT the separate "external" campaigns-style API, since
 * notifications are a GS-Backend feature, not an SMS/IVR platform call.
 * See docs/notifications-frd-and-design.md §10.
 */
class NotificationService {
  /**
   * Get paginated notifications list for the admin table.
   * @param {Object} filters
   * @param {string} filters.status - draft | scheduled | published | archived
   * @param {string} filters.category - release_note | model_deprecation | emergency
   * @param {number} filters.page
   * @param {number} filters.pageSize
   */
  async getNotificationsList(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append("status", filters.status);
      if (filters.category) params.append("category", filters.category);
      params.append("page", filters.page || 1);
      params.append("pageSize", filters.pageSize || 20);

      const response = await api.get(`/admin/notifications?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications list:", error);
      throw error;
    }
  }

  async getNotification(notificationId) {
    try {
      const response = await api.get(`/admin/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching notification:", error);
      throw error;
    }
  }

  async createNotification(payload) {
    try {
      const response = await api.post(`/admin/notifications`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating notification:", error);
      throw error;
    }
  }

  async updateNotification(notificationId, payload) {
    try {
      const response = await api.put(`/admin/notifications/${notificationId}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating notification:", error);
      throw error;
    }
  }

  async publishNotification(notificationId) {
    try {
      const response = await api.post(`/admin/notifications/${notificationId}/publish`);
      return response.data;
    } catch (error) {
      console.error("Error publishing notification:", error);
      throw error;
    }
  }

  async archiveNotification(notificationId) {
    try {
      const response = await api.post(`/admin/notifications/${notificationId}/archive`);
      return response.data;
    } catch (error) {
      console.error("Error archiving notification:", error);
      throw error;
    }
  }

  async deleteNotification(notificationId) {
    try {
      await api.delete(`/admin/notifications/${notificationId}`);
    } catch (error) {
      console.error("Error deleting notification:", error);
      throw error;
    }
  }

  async processDeprecation(notificationId) {
    try {
      const response = await api.post(`/admin/notifications/${notificationId}/process-deprecation`);
      return response.data;
    } catch (error) {
      console.error("Error processing deprecation:", error);
      throw error;
    }
  }

}

const notificationService = new NotificationService();
export default notificationService;
